// Create react app has a weird env var pattern
// where a .env file is read during development,
// but also during build, meaning env vars are passed
// only during build time, not run time, for your production
// sites (makes sense, really: they're static files.)
//
// So we load an env.js file and put them on window.ENV,
// but just for fun let's be backwards compatible too
// b/c it's unclear to me how annoying this will be in dev yet.
const ENV = window.ENV || {};

window.VITE_ENV = import.meta.env;

export const getEnv = (value, defaultValue) => {
    if (Object.prototype.hasOwnProperty.call(ENV, value)) {
        return ENV[value];
    } else if (Object.prototype.hasOwnProperty.call(import.meta.env, value)) {
        return import.meta.env[value];
    } else {
        return defaultValue;
    }
};
